<template>
  <div class="management-mobile">
    <TopNavBarMobile :classId="classId" :subjectIndex="subjectIndex" />
    
    <div class="management-header">
      <el-button class="back-btn" @click="goBack" icon="el-icon-arrow-left" size="small">返回</el-button>
      <span class="page-title">管理</span>
    </div>
    
    <div class="management-content">
      <el-tabs v-model="activeTab" class="management-tabs">
        <el-tab-pane label="班级相关" name="class">
          <div class="tab-content">
            <div class="form-section">
              <div class="form-item">
                <label>班级识别码：</label>
                <div class="class-code-row">
                  <span class="class-code">{{ classManagementForm.classCode }}</span>
                  <el-button size="small" type="primary" @click="copyClassCode">复制</el-button>
                </div>
              </div>
              
              <div class="form-item">
                <label>班级级别：</label>
                <el-select v-model="classManagementForm.grade" placeholder="请选择" @change="updateClassGrade" class="full-select">
                  <el-option v-for="grade in gradeOptions" :key="grade.value" :label="grade.label" :value="grade.value"></el-option>
                </el-select>
              </div>
              
              <div class="form-item">
                <label>班级班别：</label>
                <el-select v-model="classManagementForm.classNumber" placeholder="请选择" @change="updateClassNumber" class="full-select">
                  <el-option v-for="classNumber in classNumberOptions" :key="classNumber.value" :label="classNumber.label" :value="classNumber.value"></el-option>
                </el-select>
              </div>
            </div>
            
            <div class="student-section">
              <div class="section-header">
                <span class="section-title">学生名单</span>
                <div class="section-actions">
                  <el-button size="small" type="danger" @click="removeSelectedStudents" :disabled="multipleSelection.length === 0">删除选中</el-button>
                  <el-button size="small" type="primary" @click="addStudents">添加学生</el-button>
                </div>
              </div>
              
              <div class="student-list">
                <div class="student-table-header">
                  <div class="header-checkbox" @click="toggleSelectAll">
                    <i :class="isAllSelected ? 'el-icon-check' : 'el-icon-circle-check-outline'"></i>
                  </div>
                  <div class="header-number">学号</div>
                  <div class="header-name">姓名</div>
                  <div class="header-actions">操作</div>
                </div>
                <div 
                  v-for="(student, index) in classManagementForm.students" 
                  :key="student.id" 
                  class="student-item"
                  :class="{ selected: isSelected(student.id) }">
                  <div class="student-checkbox" @click.stop="toggleSelect(student)">
                    <i :class="isSelected(student.id) ? 'el-icon-check' : 'el-icon-circle-check-outline'"></i>
                  </div>
                  <div class="student-number">{{ student.studentNumber }}</div>
                  <div class="student-name">{{ student.name }}</div>
                  <div class="student-actions">
                    <el-button type="text" size="small" @click.stop="editStudent(student)">编辑</el-button>
                    <el-button type="text" size="small" class="danger-btn" @click.stop="deleteStudent(student)">删除</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="作业相关" name="homework">
          <div class="tab-content">
            <div class="homework-type-section">
              <div class="section-header">
                <span class="section-title">作业类型管理</span>
              </div>
              
              <div class="subject-type-list">
                <div v-for="(subject, index) in homeworkTypesTreeData" :key="subject.id" class="subject-type-group" :class="{ 'disabled-subject': isSubjectDisabledById(subject.id) }">
                  <div class="subject-header">
                    <span class="subject-name">{{ subject.label }}</span>
                    <el-button type="text" size="small" :disabled="isSubjectDisabledById(subject.id) || isHomeworkTypeLimitReached(subject)" @click="addHomeworkTypeToSubject(subject)">+添加</el-button>
                  </div>
                  <div class="type-list">
                    <div v-for="type in subject.children" :key="type.id" class="type-item" :class="{ 'disabled-type': isSubjectDisabledById(subject.id) }">
                      <span class="type-name">{{ type.label }}</span>
                      <div class="type-actions">
                        <el-button type="text" size="small" :disabled="isSubjectDisabledById(subject.id)" @click="renameHomeworkType(type, subject)">重命名</el-button>
                        <el-button type="text" size="small" :disabled="isSubjectDisabledById(subject.id)" @click="moveHomeworkType(type, subject, 'up')">上移</el-button>
                        <el-button type="text" size="small" :disabled="isSubjectDisabledById(subject.id)" @click="moveHomeworkType(type, subject, 'down')">下移</el-button>
                        <el-button type="text" size="small" class="danger-btn" :disabled="isSubjectDisabledById(subject.id)" @click="removeHomeworkType(type)">删除</el-button>
                      </div>
                    </div>
                    <div v-if="!subject.children || subject.children.length === 0" class="empty-tip">
                      暂无作业类型
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="homework-records-section">
              <div class="section-header">
                <span class="section-title">作业记录[{{ currentSubjectName }}]</span>
                <el-button size="small" type="danger" @click="removeSelectedHomeworkRecords" :disabled="homeworkMultipleSelection.length === 0">删除选中</el-button>
              </div>
              
              <div class="sort-buttons">
                <div class="select-all-area" @click="toggleRecordSelectAll">
                  <i :class="isAllRecordsSelected ? 'el-icon-check' : 'el-icon-circle-check-outline'"></i>
                  <span class="select-all-text">全选</span>
                </div>
                <div class="sort-actions">
                  <el-button 
                    size="mini" 
                    :type="sortField === 'date' ? 'primary' : 'default'"
                    @click="toggleDateSort">
                    按日期排序 {{ sortField === 'date' ? (sortOrder === 'asc' ? '↑' : '↓') : '' }}
                  </el-button>
                  <el-button 
                    size="mini" 
                    :type="sortField === 'typeName' ? 'primary' : 'default'"
                    @click="toggleTypeSort">
                    按类型排序 {{ sortField === 'typeName' ? (sortOrder === 'asc' ? '↑' : '↓') : '' }}
                  </el-button>
                </div>
              </div>
              
              <div class="record-list">
                <div 
                  v-for="record in homeworkRecords" 
                  :key="record.date + record.homeworkTypeId"
                  class="record-item"
                  :class="{ selected: isRecordSelected(record), 'group-row-light': getGroupIndex(record) % 2 === 0, 'group-row-dark': getGroupIndex(record) % 2 === 1 }">
                  <div class="record-checkbox" @click.stop="toggleRecordSelect(record)">
                    <i :class="isRecordSelected(record) ? 'el-icon-check' : 'el-icon-circle-check-outline'"></i>
                  </div>
                  <div class="record-info">
                    <div class="record-main">
                      <span class="record-date">{{ record.date }}</span>
                      <div class="record-main-right">
                        <span class="record-type">{{ record.typeName }}</span>
                        <div class="record-actions">
                          <el-button type="text" size="small" @click.stop="editHomeworkContent(record)">修改</el-button>
                          <el-button type="text" size="small" class="danger-btn" @click.stop="deleteHomeworkRecord(record)">删除</el-button>
                        </div>
                      </div>
                    </div>
                    <div class="record-content">{{ record.content || '无内容' }}</div>
                    <div class="record-stats">
                      <span class="finished">已订正: {{ record.finishedCount }}</span>
                      <span class="unfinished">未订正: {{ record.unfinishedCount }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="homeworkRecords.length === 0" class="empty-tip">
                  暂无作业记录
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="个人相关" name="personal">
          <div class="tab-content">
            <div class="personal-section">
              <div class="section-header">
                <span class="section-title">我的信息</span>
                <div class="section-actions">
                  <el-button v-if="!isEditingPersonalInfo" size="small" @click="startEditPersonalInfo">修改</el-button>
                  <template v-else>
                    <el-button size="small" @click="cancelEditPersonalInfo">取消</el-button>
                    <el-button size="small" type="primary" @click="savePersonalInfo">保存</el-button>
                  </template>
                </div>
              </div>
              
              <div class="form-section">
                <div class="form-item">
                  <label>我的昵称：</label>
                  <el-input v-model="myNickname" :disabled="!isEditingPersonalInfo" placeholder="请输入昵称"></el-input>
                </div>
                <div class="form-item">
                  <label>我的邮箱：</label>
                  <el-input v-model="myEmail" :disabled="!isEditingPersonalInfo" placeholder="请输入邮箱"></el-input>
                </div>
                <div class="form-item">
                  <label>我的手机：</label>
                  <el-input v-model="myPhone" :disabled="!isEditingPersonalInfo" placeholder="请输入手机号"></el-input>
                </div>
              </div>
              
              <div class="personal-actions">
                <el-button size="small" type="primary" @click="showChangePasswordDialog">修改密码</el-button>
                <el-button size="small" type="danger" @click="handleLogout">退出登录</el-button>
              </div>
            </div>
            
            <div class="my-classes-section">
              <div class="section-header">
                <span class="section-title">我的班级</span>
                <div class="section-actions">
                  <el-button size="small" type="primary" @click="goToNewClass" :disabled="myClasses.length >= 5">新建班级</el-button>
                  <el-button size="small" type="primary" @click="goToJoinClass" :disabled="myClasses.length >= 5">加入班级</el-button>
                  <el-button size="small" type="danger" @click="confirmUnbindClass">解绑班级</el-button>
                </div>
              </div>
              
              <div class="class-list">
                <div 
                  v-for="classInfo in myClasses" 
                  :key="classInfo.id"
                  class="class-item"
                  :class="{ current: isCurrentClass(classInfo) }"
                  @click="switchToClass(classInfo)">
                  <div class="class-main">
                    <span class="class-name">{{ classInfo.name }} - {{ classInfo.subjectName }}</span>
                    <span class="student-count">{{ classInfo.studentCount }}人</span>
                  </div>
                  <div class="other-subjects">
                    <span v-for="subjectName in ['语文', '数学', '英语'].filter(s => s !== classInfo.subjectName)" :key="subjectName" class="subject-tag">
                      {{ subjectName }}：{{ classInfo.otherSubjects[subjectName] || '未绑定' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="关于" name="about">
          <div class="tab-content about-content">
            <div class="about-section">
              <h3>项目简介</h3>
              <p class="intro-text">本项目是一个基于Spring Boot和Vue.js开发的作业批改管理系统，旨在帮助教师高效管理班级作业、学生信息以及作业记录。系统采用前后端分离架构，支持PC端和移动端访问，为教师提供便捷的作业管理工具。</p>
              <p class="intro-text">系统支持多班级管理、多科目作业类型自定义、作业记录统计、学生作业追踪等功能，有效提升教师工作效率，让作业管理更加智能化、便捷化。</p>
            </div>
            
            <div class="about-section">
              <h3>功能特性</h3>
              <ul class="feature-list">
                <li class="feature-item"><i class="el-icon-check"></i><span>多班级管理：支持同时管理多个班级，每个班级可独立设置作业类型和科目</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>多科目支持：支持语文、数学、英语三大科目，每个科目可自定义作业类型</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>作业记录管理：记录每日作业内容，支持快速添加、修改和删除作业记录</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>学生作业追踪：实时跟踪学生作业完成情况，已订正和未订正一目了然</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>快速录入：支持批量添加学生、手动快录、导入学生名单等多种录入方式</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>主题切换：支持语文、数学、英语三种主题，界面美观，操作便捷</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>移动端适配：完美支持手机端访问，随时随地管理作业</span></li>
                <li class="feature-item"><i class="el-icon-check"></i><span>数据统计：自动统计作业完成率，帮助教师了解班级整体情况</span></li>
              </ul>
            </div>
            
            <div class="about-section">
              <h3>技术栈</h3>
              <div class="tech-items">
                <div class="tech-item">
                  <div class="tech-icon backend">后端</div>
                  <div class="tech-details">
                    <p class="tech-name">Spring Boot</p>
                    <p class="tech-desc">基于Spring Boot框架，提供RESTful API接口</p>
                  </div>
                </div>
                <div class="tech-item">
                  <div class="tech-icon frontend">前端</div>
                  <div class="tech-details">
                    <p class="tech-name">Vue.js + Element UI</p>
                    <p class="tech-desc">使用Vue.js框架和Element UI组件库</p>
                  </div>
                </div>
                <div class="tech-item">
                  <div class="tech-icon database">数据库</div>
                  <div class="tech-details">
                    <p class="tech-name">MySQL</p>
                    <p class="tech-desc">使用MySQL数据库存储数据</p>
                  </div>
                </div>
                <div class="tech-item">
                  <div class="tech-icon auth">认证</div>
                  <div class="tech-details">
                    <p class="tech-name">JWT</p>
                    <p class="tech-desc">使用JWT进行用户身份认证</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="about-section">
              <h3>作者信息</h3>
              <div class="author-details">
                <div class="author-basic">
                  <p><strong>作者：</strong>林老师</p>
                  <p><strong>版本：</strong>v1.0.0</p>
                  <p><strong>更新时间：</strong>2026年2月</p>
                </div>
                <div class="wechat-qrcode">
                  <p class="wechat-label"><strong>微信二维码</strong></p>
                  <p class="wechat-tip">扫码添加作者微信，获取更多帮助</p>
                  <img src="/images/wechat-qrcode.png" alt="微信二维码" class="qrcode-image" />
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    
    <el-dialog
      title="添加学生"
      :visible.sync="showAddStudentsDialog"
      width="90%"
      :close-on-click-modal="false">
      <div class="add-students-tip">
        <p>请按以下格式输入学生姓名：</p>
        <p class="sub-tip">（每行一个学生姓名，仅限汉字，最多4个字）</p>
      </div>
      <el-input
        type="textarea"
        :rows="8"
        v-model="addStudentsText"
        :placeholder="addStudentsPlaceholder">
      </el-input>
      <div slot="footer">
        <el-button @click="showAddStudentsDialog = false; addStudentsText = '';">取消</el-button>
        <el-button type="primary" @click="importAddedStudents">确定</el-button>
      </div>
    </el-dialog>
    
    <el-dialog
      title="编辑学生信息"
      :visible.sync="studentEditDialogVisible"
      width="85%"
      :close-on-click-modal="false">
      <div class="edit-form">
        <div class="form-item">
          <label>学号：</label>
          <el-input v-model="currentStudent.studentNumber" placeholder="请输入学号"></el-input>
        </div>
        <div class="form-item">
          <label>姓名：</label>
          <el-input v-model="currentStudent.name" placeholder="请输入学生姓名"></el-input>
        </div>
        <div class="form-item">
          <label>拼音首字母：</label>
          <el-input v-model="currentStudent.pinyinInitials" placeholder="请输入拼音首字母"></el-input>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="studentEditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveStudentInfo">确定</el-button>
      </div>
    </el-dialog>
    
    <el-dialog
      title="修改密码"
      :visible.sync="changePasswordDialogVisible"
      width="85%"
      :close-on-click-modal="false">
      <div class="edit-form">
        <div class="form-item">
          <label>原密码：</label>
          <el-input type="password" v-model="changePasswordForm.oldPassword" placeholder="请输入原密码" show-password></el-input>
        </div>
        <div class="form-item">
          <label>新密码：</label>
          <el-input type="password" v-model="changePasswordForm.newPassword" placeholder="请输入新密码" show-password></el-input>
        </div>
        <div class="form-item">
          <label>确认密码：</label>
          <el-input type="password" v-model="changePasswordForm.confirmPassword" placeholder="请再次输入新密码" show-password></el-input>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="changePasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="changePassword">确定</el-button>
      </div>
    </el-dialog>
    
    <el-dialog
      title="修改作业内容"
      :visible.sync="homeworkContentDialogVisible"
      width="90%"
      :close-on-click-modal="false">
      <el-input
        type="textarea"
        :rows="6"
        v-model="tempHomeworkContent"
        placeholder="请输入作业内容">
      </el-input>
      <div slot="footer">
        <el-button @click="homeworkContentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveHomeworkContent">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopNavBarMobile from '@/components/mobile/TopNavBarMobile.vue'
import EventBus from '@/utils/EventBus'
import Utils from '@/utils/Utils'
import logoutMixin from '@/mixins/logoutMixin.js'

export default {
  name: 'ManagementMobile',
  mixins: [logoutMixin],
  components: {
    TopNavBarMobile
  },
  props: {
    classId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      subjectIndex: 0,
      activeTab: 'class',
      classManagementForm: {
        classCode: '',
        grade: '',
        classNumber: null,
        students: [],
        chineseHomeworkTypes: [],
        mathHomeworkTypes: [],
        englishHomeworkTypes: []
      },
      homeworkTypesTreeData: [
        { id: 1, label: '语文', type: 'subject', children: [] },
        { id: 2, label: '数学', type: 'subject', children: [] },
        { id: 3, label: '英语', type: 'subject', children: [] }
      ],
      homeworkRecords: [],
      multipleSelection: [],
      homeworkMultipleSelection: [],
      gradeOptions: [
        { value: 1, label: '一年级' }, { value: 2, label: '二年级' }, { value: 3, label: '三年级' },
        { value: 4, label: '四年级' }, { value: 5, label: '五年级' }, { value: 6, label: '六年级' },
        { value: 7, label: '初一' }, { value: 8, label: '初二' }, { value: 9, label: '初三' },
        { value: 10, label: '高一' }, { value: 11, label: '高二' }, { value: 12, label: '高三' }
      ],
      classNumberOptions: Array.from({ length: 20 }, (_, i) => ({ value: i + 1, label: `${i + 1}班` })),
      showAddStudentsDialog: false,
      addStudentsText: '',
      addStudentsPlaceholder: '请输入学生姓名，每行一个学生' + String.fromCharCode(10) + '格式示例：' + String.fromCharCode(10) + '张三' + String.fromCharCode(10) + '李四' + String.fromCharCode(10) + '王五',
      studentEditDialogVisible: false,
      currentStudent: {},
      isEditingPersonalInfo: false,
      myNickname: '',
      myEmail: '',
      myPhone: '',
      myClasses: [],
      changePasswordDialogVisible: false,
      changePasswordForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
      homeworkContentDialogVisible: false,
      tempHomeworkContent: '',
      editingHomeworkRecord: null,
      teacherSubjectIds: [],
      sortField: 'date',
      sortOrder: 'desc',
      lastSort: { field: 'date', order: 'descending' }
    }
  },
  computed: {
    currentSubjectName() {
      const names = ['语文', '数学', '英语'];
      return names[this.subjectIndex] || '未知';
    },
    isAllSelected() {
      return this.classManagementForm.students.length > 0 && 
             this.multipleSelection.length === this.classManagementForm.students.length;
    },
    isAllRecordsSelected() {
      return this.homeworkRecords.length > 0 && 
             this.homeworkMultipleSelection.length === this.homeworkRecords.length;
    }
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 'class') {
        this.loadClassManagementData();
      } else if (newVal === 'homework') {
        this.loadHomeworkManagementData();
      } else if (newVal === 'personal') {
        this.loadPersonalInfo();
        this.loadMyClasses();
      }
    }
  },
  created() {
    this.loadSubjectIndex();
    this.loadClassManagementData();
    document.body.style.setProperty('padding-left', '0', 'important');
    document.body.style.setProperty('padding-right', '0', 'important');
  },
  beforeDestroy() {
    document.body.style.removeProperty('padding-left');
    document.body.style.removeProperty('padding-right');
  },
  methods: {
    loadSubjectIndex() {
      const savedState = sessionStorage.getItem('mobileNavState');
      if (savedState) {
        try {
          const state = JSON.parse(savedState);
          this.subjectIndex = state.subjectIndex || 0;
        } catch (e) {
          this.subjectIndex = 0;
        }
      }
    },
    goBack() {
      this.$router.push(`/mobile/more/${this.classId}`);
    },
    loadClassManagementData() {
      this.$http.get(`/classes/${this.classId}`).then(response => {
        if (response.data.success && response.data.class) {
          const classInfo = response.data.class;
          this.classManagementForm.classCode = classInfo.classCode;
          this.classManagementForm.grade = classInfo.gradeLevel;
          this.classManagementForm.classNumber = parseInt(classInfo.classNumber);
          this.loadStudentsForManagement();
        }
      }).catch(error => {
        console.error('加载班级管理信息失败:', error);
        this.$message.error('加载班级管理信息失败');
      });
    },
    loadStudentsForManagement() {
      this.$http.get(`/students/class?classId=${this.classId}`).then(response => {
        this.classManagementForm.students = response.data.sort((a, b) => {
          const numA = parseInt(a.studentNumber, 10) || 0;
          const numB = parseInt(b.studentNumber, 10) || 0;
          return numA - numB;
        });
      }).catch(error => {
        console.error('加载学生信息失败:', error);
      });
    },
    loadHomeworkManagementData() {
      this.getCurrentTeacherSubjects().then(() => {
        this.loadHomeworkTypesForManagement();
        this.loadHomeworkRecords();
      });
    },
    getCurrentTeacherSubjects() {
      return this.$http.get('/teacherClass/getTeacherSubjects', {
        params: { classId: this.classId }
      }).then(response => {
        if (response.data.success && response.data.subjectIds) {
          this.teacherSubjectIds = response.data.subjectIds;
        }
      }).catch(error => {
        console.error('获取教师任教科目失败:', error);
      });
    },
    loadHomeworkTypesForManagement() {
      this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=1`).then(response => {
        this.classManagementForm.chineseHomeworkTypes = response.data;
        return this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=2`);
      }).then(response => {
        this.classManagementForm.mathHomeworkTypes = response.data;
        return this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=3`);
      }).then(response => {
        this.classManagementForm.englishHomeworkTypes = response.data;
        this.initHomeworkTypesTree();
      }).catch(error => {
        console.error('加载作业类型失败:', error);
      });
    },
    initHomeworkTypesTree() {
      this.homeworkTypesTreeData = [
        { id: 1, label: '语文', type: 'subject', children: [] },
        { id: 2, label: '数学', type: 'subject', children: [] },
        { id: 3, label: '英语', type: 'subject', children: [] }
      ];
      if (this.classManagementForm.chineseHomeworkTypes) {
        this.homeworkTypesTreeData[0].children = this.classManagementForm.chineseHomeworkTypes.map(type => ({
          id: type.id, label: type.name, type: 'homework'
        }));
      }
      if (this.classManagementForm.mathHomeworkTypes) {
        this.homeworkTypesTreeData[1].children = this.classManagementForm.mathHomeworkTypes.map(type => ({
          id: type.id, label: type.name, type: 'homework'
        }));
      }
      if (this.classManagementForm.englishHomeworkTypes) {
        this.homeworkTypesTreeData[2].children = this.classManagementForm.englishHomeworkTypes.map(type => ({
          id: type.id, label: type.name, type: 'homework'
        }));
      }
    },
    loadHomeworkRecords() {
      this.homeworkRecords = [];
      this.$http.get(`/homeworkAssignments/class/${this.classId}/details`)
        .then(response => {
          if (response.data.success) {
            this.homeworkRecords = response.data.data || [];
            this.sortHomeworkRecords();
          }
        })
        .catch(error => {
          console.error('加载作业记录失败:', error);
        });
    },
    loadPersonalInfo() {
      this.$http.get('/teachers/profile').then(response => {
        if (response.data.success) {
          const profile = response.data.profile;
          this.myNickname = profile.nickname || '';
          this.myEmail = profile.email || '';
          this.myPhone = profile.phone || '';
        }
      }).catch(error => {
        console.error('加载个人信息失败:', error);
      });
    },
    loadMyClasses() {
      this.$http.get('/teachers/myClasses').then(response => {
        if (response.data.success) {
          const classPromises = response.data.classes.map(cls => {
            return this.$http.get(`/students/class?classId=${cls.id}`).then(studentsResponse => {
              const studentCount = studentsResponse.data ? studentsResponse.data.length : 0;
              return this.$http.get(`/teachers/${cls.id}/teachers-by-class`).then(classTeachersResponse => {
                let otherSubjects = {};
                if (classTeachersResponse.data.success && classTeachersResponse.data.teachers) {
                  for (const teacherInfo of classTeachersResponse.data.teachers) {
                    if (cls.subjectId !== teacherInfo.subjectId) {
                      const subjectName = this.getSubjectNameById(teacherInfo.subjectId);
                      otherSubjects[subjectName] = teacherInfo.teacherNickname;
                    }
                  }
                }
                const allSubjects = ['语文', '数学', '英语'];
                for (const subject of allSubjects) {
                  if (subject !== cls.subjectName && !(subject in otherSubjects)) {
                    otherSubjects[subject] = '未绑定';
                  }
                }
                return { id: cls.id, name: cls.name, subjectName: cls.subjectName, subjectId: cls.subjectId, studentCount, otherSubjects };
              }).catch(() => {
                const otherSubjects = {};
                const allSubjects = ['语文', '数学', '英语'];
                for (const subject of allSubjects) {
                  if (subject !== cls.subjectName) {
                    otherSubjects[subject] = '未绑定';
                  }
                }
                return { id: cls.id, name: cls.name, subjectName: cls.subjectName, subjectId: cls.subjectId, studentCount, otherSubjects };
              });
            }).catch(() => ({ id: cls.id, name: cls.name, subjectName: cls.subjectName, subjectId: cls.subjectId, studentCount: 0, otherSubjects: {} }));
          });
          Promise.all(classPromises).then(classes => {
            this.myClasses = classes;
          });
        }
      }).catch(error => {
        console.error('加载我的班级失败:', error);
      });
    },
    getSubjectNameById(subjectId) {
      const names = { 1: '语文', 2: '数学', 3: '英语' };
      return names[subjectId] || '未知';
    },
    copyClassCode() {
      const classCode = this.classManagementForm.classCode;
      if (!classCode) {
        this.$message.warning('班级识别码为空');
        return;
      }
      const className = Utils.formatClassName(this.classManagementForm.grade, this.classManagementForm.classNumber);
      const text = `班级：${className}的班级识别码是：${classCode}，请勿将该班级识别码外传给陌生人。`;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('班级信息复制成功');
        }).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    getChineseGrade(gradeLevel) {
      const grades = { 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '初一', 8: '初二', 9: '初三', 10: '高一', 11: '高二', 12: '高三' };
      return grades[gradeLevel] || gradeLevel;
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.$message.success('班级信息复制成功');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(textArea);
    },
    updateClassGrade() {
      this.$http.put(`/classes/update?classId=${this.classId}`, {
        gradeLevel: this.classManagementForm.grade,
        classNumber: this.classManagementForm.classNumber,
        classCode: this.classManagementForm.classCode
      }).then(response => {
        if (response.data.success) {
          this.$message.success('班级级别更新成功');
        } else {
          this.$message.error(response.data.message || '更新失败');
        }
      }).catch(error => {
        this.$message.error('更新失败');
      });
    },
    updateClassNumber() {
      this.$http.put(`/classes/update?classId=${this.classId}`, {
        classNumber: this.classManagementForm.classNumber,
        gradeLevel: this.classManagementForm.grade,
        classCode: this.classManagementForm.classCode
      }).then(response => {
        if (response.data.success) {
          this.$message.success('班级班别更新成功');
          this.loadMyClasses();
        } else {
          this.$message.error(response.data.message || '更新失败');
        }
      }).catch(error => {
        this.$message.error('更新失败');
      });
    },
    isSelected(studentId) {
      return this.multipleSelection.some(s => s.id === studentId);
    },
    toggleSelect(student) {
      const index = this.multipleSelection.findIndex(s => s.id === student.id);
      if (index > -1) {
        this.multipleSelection.splice(index, 1);
      } else {
        this.multipleSelection.push(student);
      }
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.multipleSelection = [];
      } else {
        this.multipleSelection = [...this.classManagementForm.students];
      }
    },
    toggleRecordSelectAll() {
      if (this.isAllRecordsSelected) {
        this.homeworkMultipleSelection = [];
      } else {
        this.homeworkMultipleSelection = [...this.homeworkRecords];
      }
    },
    isRecordSelected(record) {
      return this.homeworkMultipleSelection.some(r => r.date === record.date && r.homeworkTypeId === record.homeworkTypeId);
    },
    toggleRecordSelect(record) {
      const index = this.homeworkMultipleSelection.findIndex(r => r.date === record.date && r.homeworkTypeId === record.homeworkTypeId);
      if (index > -1) {
        this.homeworkMultipleSelection.splice(index, 1);
      } else {
        this.homeworkMultipleSelection.push(record);
      }
    },
    addStudents() {
      this.showAddStudentsDialog = true;
      this.addStudentsText = '';
    },
    removeSelectedStudents() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一名学生');
        return;
      }
      this.$confirm(`确定要删除选中的${this.multipleSelection.length}名学生吗？`, '提示', { type: 'warning' }).then(() => {
        const studentIds = this.multipleSelection.map(s => s.id);
        this.$http.post('/students/delete', { ids: studentIds }).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message);
            this.loadStudentsForManagement();
            this.multipleSelection = [];
            EventBus.$emit('student-deleted', { studentIds, classId: this.classId });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    editStudent(student) {
      this.currentStudent = { ...student };
      this.studentEditDialogVisible = true;
    },
    deleteStudent(student) {
      this.$confirm(`确定要删除学生 "${student.name}" 吗？`, '提示', { type: 'warning' }).then(() => {
        this.$http.post('/students/delete', { ids: [student.id] }).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message);
            this.loadStudentsForManagement();
            EventBus.$emit('student-deleted', { studentIds: [student.id], classId: this.classId });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    saveStudentInfo() {
      if (!this.currentStudent.name || !this.currentStudent.name.trim()) {
        this.$message.error('学生姓名不能为空');
        return;
      }
      if (!this.currentStudent.studentNumber || !this.currentStudent.studentNumber.trim()) {
        this.$message.error('学号不能为空');
        return;
      }
      if (!this.currentStudent.pinyinInitials || !this.currentStudent.pinyinInitials.trim()) {
        this.$message.error('拼音首字母不能为空');
        return;
      }
      if (!/^[a-zA-Z]+$/.test(this.currentStudent.pinyinInitials.trim())) {
        this.$message.error('拼音首字母只能包含字母');
        return;
      }
      this.currentStudent.pinyinInitials = this.currentStudent.pinyinInitials.toLowerCase().trim();
      this.$http.put('/students', this.currentStudent, { params: { id: this.currentStudent.id } }).then(response => {
        if (response.data && response.data.success) {
          this.loadStudentsForManagement();
          this.$message.success(response.data.message || '保存成功');
          this.studentEditDialogVisible = false;
          EventBus.$emit('student-info-updated', { student: response.data.student, classId: this.classId });
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      }).catch(error => {
        this.$message.error(error.response?.data?.message || '保存失败');
      });
    },
    importAddedStudents() {
      if (!this.addStudentsText.trim()) {
        this.$message.warning('请输入学生信息');
        return;
      }

      const lines = this.addStudentsText.split('\n').filter(line => line.trim() !== '');
      const invalidLines = [];
      const validStudents = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line === '') continue;

        if (!/^[一-\u9fa5]{1,4}$/.test(line)) {
          invalidLines.push({ line: i + 1, content: line });
        } else {
          validStudents.push({
            name: line,
            originalLine: i + 1
          });
        }
      }

      if (invalidLines.length > 0) {
        let errorMsg = '以下行格式不正确（格式：姓名，每行一个，不带学号与标点符号，不超过4个汉字）：\n';
        invalidLines.forEach(item => {
          errorMsg += `第${item.line}行: ${item.content}\n`;
        });
        this.$alert(errorMsg.replace(/\n/g, '<br/>'), '格式错误', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        });
        return;
      }

      let existingStudents = [];
      this.$http.get(`/students/class?classId=${this.classId}`).then(response => {
        existingStudents = response.data || [];

        const currentStudentCount = existingStudents.length;
        const newStudentCount = validStudents.length;
        if (currentStudentCount + newStudentCount > 70) {
          this.$alert(
            `添加失败：班级人数不能超过70人<br/>
             当前已有：${currentStudentCount}人<br/>
             本次添加：${newStudentCount}人<br/>
             总计：${currentStudentCount + newStudentCount}人`,
            '人数超限', {
            confirmButtonText: '确定',
            type: 'error',
            dangerouslyUseHTMLString: true
          }).catch(() => {});
          return;
        }

        this.processValidStudents(validStudents, existingStudents);
      }).catch(error => {
        console.error('获取已有学生列表失败:', error);
        this.processValidStudents(validStudents, existingStudents);
      });
    },
    processValidStudents(validStudents, existingStudents) {
      const nameCounts = {};
      const duplicateWithinInput = [];

      for (const student of validStudents) {
        if (nameCounts[student.name]) {
          nameCounts[student.name].push(student.originalLine);
        } else {
          nameCounts[student.name] = [student.originalLine];
        }
      }

      for (const [name, lines] of Object.entries(nameCounts)) {
        if (lines.length > 1) {
          duplicateWithinInput.push({
            name: name,
            lines: lines
          });
        }
      }

      const duplicateWithExisting = [];
      for (const student of validStudents) {
        const isDuplicate = existingStudents.some(existingStudent => existingStudent.name === student.name);
        if (isDuplicate) {
          duplicateWithExisting.push({
            name: student.name,
            line: student.originalLine
          });
        }
      }

      if (duplicateWithinInput.length > 0 || duplicateWithExisting.length > 0) {
        let errorMsg = '发现重名学生，请修改后再添加：\n';

        if (duplicateWithinInput.length > 0) {
          duplicateWithinInput.forEach(dup => {
            errorMsg += `姓名"${dup.name}"在第${dup.lines.join('、')}行重复\n`;
          });
        }

        if (duplicateWithExisting.length > 0) {
          duplicateWithExisting.forEach(dup => {
            errorMsg += `姓名"${dup.name}"与已有学生重名（第${dup.line}行）\n`;
          });
        }

        errorMsg = errorMsg.trimEnd();

        this.$alert(errorMsg.replace(/\n/g, '<br/>'), '重名检查', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        }).catch(() => {});
        return;
      }

      const studentNames = validStudents.map(student => student.name);
      this.$http.post('/students/batch', { classId: parseInt(this.classId), studentNames }).then(response => {
        if (response.data.success) {
          this.$message.success(response.data.message);
          this.showAddStudentsDialog = false;
          this.addStudentsText = '';
          this.loadStudentsForManagement();
          EventBus.$emit('student-added', { classId: this.classId, count: studentNames.length });
        } else {
          this.$message.error(response.data.message || '添加失败');
        }
      }).catch(error => {
        this.$message.error(error.response?.data?.message || '添加失败');
      });
    },
    addHomeworkTypeToSubject(subject) {
      this.$prompt('请输入作业类型名称', '添加作业类型', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          if (!value || value.trim() === '') return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          return true;
        }
      }).then(({ value }) => {
        this.$http.post('/homeworkTypes/addToSubject', {
          name: value.trim(),
          subjectId: subject.id,
          classId: this.classId
        }).then(response => {
          if (response.data && response.data.success) {
            const homeworkTypeData = response.data.homeworkType;
            if (!subject.children) subject.children = [];
            subject.children.push({ id: homeworkTypeData.id, label: homeworkTypeData.name, type: 'homework' });
            this.$message.success(response.data.message || '添加成功');
            EventBus.$emit('homework-types-updated', { classId: this.classId, subjectId: subject.id, operation: 'add', data: homeworkTypeData });
          } else {
            this.$message.error(response.data.message || '添加失败');
          }
        }).catch(error => {
          this.$message.error('添加失败');
        });
      }).catch(() => {});
    },
    renameHomeworkType(type, subject) {
      this.$prompt('请输入新的作业类型名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: type.label,
        inputValidator: (value) => {
          if (!value) return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          return true;
        }
      }).then(({ value }) => {
        this.$http.put(`/homeworkTypes/${type.id}`, { name: value.trim() }).then(response => {
          if (response.data && response.data.id) {
            type.label = value;
            this.$message.success('重命名成功');
            EventBus.$emit('homework-types-updated', { classId: this.classId, subjectId: subject.id, operation: 'update', data: { id: response.data.id, name: value } });
          } else {
            this.$message.error(response.data.message || '重命名失败');
          }
        }).catch(error => {
          this.$message.error('重命名失败');
        });
      }).catch(() => {});
    },
    moveHomeworkType(type, subject, direction) {
      const siblings = subject.children;
      const index = siblings.findIndex(item => item.id === type.id);
      if (index === -1) return;
      if (direction === 'up' && index > 0) {
        [siblings[index - 1], siblings[index]] = [siblings[index], siblings[index - 1]];
      } else if (direction === 'down' && index < siblings.length - 1) {
        [siblings[index], siblings[index + 1]] = [siblings[index + 1], siblings[index]];
      } else {
        return;
      }
      this.homeworkTypesTreeData = [...this.homeworkTypesTreeData];
      const updateData = {
        subjectId: subject.id,
        homeworkTypes: siblings.map((t, i) => ({ id: t.id, name: t.label, sortOrder: i + 1 }))
      };
      this.$http.put('/homeworkTypes/updateOrder', updateData).then(response => {
        if (response.data.success || !response.data.message) {
          this.$message.success('顺序已更新');
          EventBus.$emit('homework-types-updated', { classId: this.classId, subjectId: subject.id, operation: 'move' });
        } else {
          this.$message.error('更新失败');
        }
      }).catch(error => {
        this.$message.error('更新失败');
      });
    },
    removeHomeworkType(type) {
      this.$confirm(`确定要删除作业类型 "${type.label}" 吗？`, '提示', { type: 'warning' }).then(() => {
        this.$http.delete(`/homeworkTypes/${type.id}`).then(response => {
          if (response.data && response.data.success) {
            for (const subject of this.homeworkTypesTreeData) {
              const index = subject.children.findIndex(c => c.id === type.id);
              if (index > -1) {
                subject.children.splice(index, 1);
                break;
              }
            }
            this.$message.success(response.data.message || '删除成功');
            EventBus.$emit('homework-types-updated', { classId: this.classId, operation: 'remove', data: type });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    isSubjectDisabledById(subjectId) {
      if (!this.teacherSubjectIds || this.teacherSubjectIds.length === 0) {
        return false;
      }
      return !this.teacherSubjectIds.includes(subjectId);
    },
    isHomeworkTypeLimitReached(subject) {
      if (!subject.children) {
        return false;
      }
      return subject.children.length >= 20;
    },
    toggleDateSort() {
      if (this.sortField === 'date') {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = 'date';
        this.sortOrder = 'desc';
      }
      this.lastSort = { field: 'date', order: this.sortOrder === 'asc' ? 'ascending' : 'descending' };
      this.sortHomeworkRecords();
    },
    toggleTypeSort() {
      if (this.sortField === 'typeName') {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = 'typeName';
        this.sortOrder = 'desc';
      }
      this.lastSort = { field: 'typeName', order: this.sortOrder === 'asc' ? 'ascending' : 'descending' };
      this.sortHomeworkRecords();
    },
    sortHomeworkRecords() {
      this.homeworkRecords.sort((a, b) => {
        let primaryResult = 0;
        let secondaryResult = 0;
        
        if (this.sortField === 'date') {
          primaryResult = new Date(a.date) - new Date(b.date);
          secondaryResult = (a.homeworkTypeSortOrder || 0) - (b.homeworkTypeSortOrder || 0);
        } else if (this.sortField === 'typeName') {
          primaryResult = (a.homeworkTypeSortOrder || 0) - (b.homeworkTypeSortOrder || 0);
          secondaryResult = new Date(a.date) - new Date(b.date);
        }
        
        if (this.sortOrder === 'desc') {
          primaryResult = -primaryResult;
        }
        
        if (primaryResult === 0) {
          return secondaryResult;
        }
        
        return primaryResult;
      });
    },
    getGroupIndex(record) {
      const groupValues = this.homeworkRecords.map(r => 
        this.sortField === 'date' ? r.date : r.homeworkTypeId
      );
      const uniqueGroups = [...new Set(groupValues)];
      const groupKey = this.sortField === 'date' ? record.date : record.homeworkTypeId;
      return uniqueGroups.indexOf(groupKey);
    },
    removeSelectedHomeworkRecords() {
      if (this.homeworkMultipleSelection.length === 0) {
        this.$message.warning('请至少选择一条作业记录');
        return;
      }
      this.$confirm(`确定要删除选中的${this.homeworkMultipleSelection.length}条作业记录吗？`, '提示', { type: 'warning' }).then(() => {
        const deleteParams = this.homeworkMultipleSelection.map(record => ({
          date: record.date,
          typeId: record.homeworkTypeId,
          classId: parseInt(this.classId)
        }));
        this.$http.post('/homeworkAssignments/batch-delete', deleteParams).then(response => {
          if (response.data.success) {
            this.$message.success(`成功删除${response.data.deletedCount}条作业记录`);
            this.homeworkMultipleSelection.forEach(selectedRecord => {
              const index = this.homeworkRecords.findIndex(r => r.date === selectedRecord.date && r.homeworkTypeId === selectedRecord.homeworkTypeId);
              if (index > -1) this.homeworkRecords.splice(index, 1);
            });
            this.homeworkMultipleSelection = [];
            EventBus.$emit('homework-records-batch-deleted', { records: deleteParams, classId: this.classId });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    editHomeworkContent(record) {
      this.editingHomeworkRecord = record;
      this.tempHomeworkContent = record.content || '';
      this.homeworkContentDialogVisible = true;
    },
    saveHomeworkContent() {
      if (!this.editingHomeworkRecord) return;
      this.$http.post('/homeworkContents', {
        date: this.editingHomeworkRecord.date,
        homeworkTypeId: this.editingHomeworkRecord.homeworkTypeId,
        classId: this.classId,
        content: this.tempHomeworkContent
      }).then(response => {
        this.$message.success('作业内容保存成功!');
        this.editingHomeworkRecord.content = this.tempHomeworkContent;
        this.homeworkContentDialogVisible = false;
      }).catch(error => {
        this.$message.error('更新失败');
      });
    },
    deleteHomeworkRecord(record) {
      this.$confirm(`确定要删除该作业记录吗？`, '提示', { type: 'warning' }).then(() => {
        this.$http.delete(`/homeworkAssignments/record?date=${record.date}&typeId=${record.homeworkTypeId}&classId=${this.classId}`).then(response => {
          if (response.data.success) {
            this.$message.success('删除成功');
            const index = this.homeworkRecords.findIndex(r => r.date === record.date && r.homeworkTypeId === record.homeworkTypeId);
            if (index > -1) this.homeworkRecords.splice(index, 1);
            EventBus.$emit('homework-record-deleted', {
              date: record.date,
              typeId: record.homeworkTypeId,
              classId: this.classId
            });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    startEditPersonalInfo() {
      this.isEditingPersonalInfo = true;
    },
    cancelEditPersonalInfo() {
      this.isEditingPersonalInfo = false;
      this.loadPersonalInfo();
    },
    savePersonalInfo() {
      this.$http.put('/teachers/profile', {
        nickname: this.myNickname,
        email: this.myEmail,
        phone: this.myPhone
      }).then(response => {
        if (response.data.success) {
          this.$message.success('个人资料保存成功');
          this.isEditingPersonalInfo = false;
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      }).catch(error => {
        this.$message.error('保存失败');
      });
    },
    showChangePasswordDialog() {
      this.changePasswordForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
      this.changePasswordDialogVisible = true;
    },
    changePassword() {
      if (!this.changePasswordForm.oldPassword) {
        this.$message.error('请输入原密码');
        return;
      }
      if (!this.changePasswordForm.newPassword || this.changePasswordForm.newPassword.length < 6) {
        this.$message.error('新密码长度不能少于6个字符');
        return;
      }
      if (this.changePasswordForm.newPassword !== this.changePasswordForm.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }
      this.$http.post('/teachers/changePassword', {
        oldPassword: this.changePasswordForm.oldPassword,
        newPassword: this.changePasswordForm.newPassword
      }).then(response => {
        if (response.data.success) {
          this.$message.success('密码修改成功，请重新登录');
          this.changePasswordDialogVisible = false;
          this.logoutAndRedirect('/loginmobile');
        } else {
          this.$message.error(response.data.message || '修改失败');
        }
      }).catch(error => {
        this.$message.error('修改失败');
      });
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' }).then(() => {
        this.logoutAndRedirect('/loginmobile');
      }).catch(() => {});
    },
    goToNewClass() {
      this.$router.push('/newclassmobile');
    },
    goToJoinClass() {
      this.$router.push('/joinclassmobile');
    },
    isCurrentClass(classInfo) {
      return classInfo.id == this.classId;
    },
    switchToClass(classInfo) {
      const subjectId = this.getSubjectIdByName(classInfo.subjectName);
      window.location.href = `/mobile/class/${classInfo.id}?subjectId=${subjectId}`;
    },
    getSubjectIdByName(subjectName) {
      const subjects = ['语文', '数学', '英语'];
      return subjects.indexOf(subjectName) + 1;
    },
    confirmUnbindClass() {
      const currentClass = this.myClasses.find(c => c.id == this.classId);
      const className = currentClass ? currentClass.name : '当前班级';
      this.$confirm(`解绑班级时，将同时删除您在该班级所教科目的作业类型、订正记录和作业内容数据。确定要解绑当前班级 <strong style="color: #f56c6c;">${className}</strong> 吗？`, '重要提示', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$http.get(`/teacherClass/checkTeachersCount?classId=${this.classId}`).then(checkResponse => {
          if (checkResponse.data.success && checkResponse.data.count === 1) {
            this.$confirm(`当前班级（<strong style="color: #f56c6c;">${className}</strong>）只绑定了您一位老师，如果解绑，将同时删除该班级，请问是否解绑并删除班级？`, '重要提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(() => {
              this.unbindClass(true);
            }).catch(() => {});
          } else {
            this.unbindClass(false);
          }
        }).catch(() => {
          this.unbindClass(false);
        });
      }).catch(() => {});
    },
    unbindClass(shouldDeleteClass) {
      this.$http.delete(`/teachers/unbind?classId=${this.classId}&deleteClass=${shouldDeleteClass}`).then(response => {
        if (response.data.success) {
          this.$message.success(response.data.message || '解绑成功');
          this.logoutAndRedirect('/loginmobile');
        } else {
          this.$message.error(response.data.message || '解绑失败');
        }
      }).catch(error => {
        this.$message.error('解绑失败');
      });
    }
  }
}
</script>

<style scoped>
.management-mobile {
  min-height: 100vh;
  background: #f5f7fa;
  padding-top: 44px;
}

.management-header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.back-btn {
  padding: 5px 10px;
}

.page-title {
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold;
}

.management-content {
}

.management-tabs {
  background: #fff;
}

.management-tabs ::v-deep .el-tabs__header {
  padding: 0 16px;
}

.management-tabs ::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

.tab-content {
  padding: 10px;
}

.form-section {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.form-item {
  margin-bottom: 12px;
}

.form-item label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 6px;
}

.form-item .el-input,
.form-item .el-select {
  width: 100%;
}

.full-select {
  width: 100%;
}

.class-code-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.class-code {
  flex: 1;
  font-weight: bold;
  font-size: 16px;
  color: #f56c6c;
  user-select: text;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
}

.section-actions {
  display: flex;
  gap: 8px;
}

.homework-type-section,
.personal-section,
.my-classes-section {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
}

.student-section {
  background: #fff;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
}

.student-section .section-header {
  padding: 12px 10px;
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.homework-records-section {
  background: #fff;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
}

.homework-records-section .section-header {
  padding: 12px 10px;
  margin-bottom: 0;
}

.homework-records-section .sort-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 10px;
}

.homework-records-section .select-all-area {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  margin-left: 3px;
}

.homework-records-section .select-all-area i {
  width: 16px;
  height: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: transparent;
  background: #fff;
  transition: border-color 0.25s, background-color 0.25s;
  margin-right: 6px;
}

.homework-records-section .select-all-area i.el-icon-check {
  border-color: #409EFF;
  background: #409EFF;
  color: #fff;
}

.homework-records-section .select-all-area i.el-icon-check::before {
  content: '';
  display: block;
  width: 4px;
  height: 8px;
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  transform: rotate(45deg);
  margin-top: -2px;
  margin-left: 1px;
}

.homework-records-section .select-all-text {
  font-size: 14px;
  color: #606266;
}

.sort-actions {
  display: flex;
  gap: 8px;
}

.student-list {
}

.student-table-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
  font-size: 14px;
  color: #606266;
}

.header-checkbox {
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.header-checkbox i {
  width: 16px;
  height: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: transparent;
  background: #fff;
  transition: border-color 0.25s, background-color 0.25s;
}

.header-checkbox i.el-icon-check {
  border-color: #409EFF;
  background: #409EFF;
  color: #fff;
}

.header-checkbox i.el-icon-check::before {
  content: '';
  display: block;
  width: 4px;
  height: 8px;
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  transform: rotate(45deg);
  margin-top: -2px;
  margin-left: 1px;
}

.header-number {
  width: 60px;
  text-align: center;
}

.header-name {
  flex: 1;
}

.header-actions {
  width: 80px;
  text-align: center;
}

.student-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.student-item:last-child {
  border-bottom: none;
}

.student-item.selected {
  background: #f0f7ff;
}

.student-checkbox {
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.student-number {
  width: 60px;
  text-align: center;
  color: #606266;
}

.student-name {
  flex: 1;
  color: #303133;
}

.student-checkbox i {
  width: 16px;
  height: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: transparent;
  background: #fff;
  transition: border-color 0.25s, background-color 0.25s;
}

.student-item.selected .student-checkbox i {
  border-color: #409EFF;
  background: #409EFF;
  color: #fff;
}

.student-item.selected .student-checkbox i::before {
  content: '';
  display: block;
  width: 4px;
  height: 8px;
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  transform: rotate(45deg);
  margin-top: -2px;
  margin-left: 1px;
}

.student-actions {
  width: 80px;
  display: flex;
  justify-content: center;
  gap: 4px;
}

.danger-btn {
  color: #f56c6c !important;
}

.danger-btn.is-disabled {
  color: #c0c4cc !important;
}

.subject-type-list {
  margin-top: 12px;
}

.subject-type-group {
  margin-bottom: 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.subject-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.subject-name {
  font-weight: bold;
  color: #303133;
}

.type-list {
  padding: 0 12px;
}

.type-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  min-width: 0;
}

.type-item:last-child {
  border-bottom: none;
}

.disabled-subject {
  opacity: 0.5;
  pointer-events: none;
}

.disabled-subject .subject-name {
  color: #909399;
}

.disabled-type .type-name {
  color: #c0c4cc;
}

.type-name {
  font-size: 14px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type-actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}

.empty-tip {
  color: #909399;
  font-size: 13px;
  padding: 10px 0;
  text-align: center;
}

.record-list {
}

.sort-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.record-item {
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.record-item.selected {
  background: #f0f7ff;
}

.group-row-light {
  background-color: #fafafa;
}

.group-row-dark {
  background-color: #f5f7fa;
}

.record-checkbox {
  width: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 8px;
  padding-left: 3px;
}

.record-checkbox i {
  width: 16px;
  height: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: transparent;
  background: #fff;
  transition: border-color 0.25s, background-color 0.25s;
}

.record-item.selected .record-checkbox i {
  border-color: #409EFF;
  background: #409EFF;
  color: #fff;
}

.record-item.selected .record-checkbox i::before {
  content: '';
  display: block;
  width: 4px;
  height: 8px;
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  transform: rotate(45deg);
  margin-top: -2px;
  margin-left: 1px;
}

.record-info {
  flex: 1;
  min-width: 0;
}

.record-main {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  min-width: 0;
}

.record-main-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.record-date {
  color: #606266;
  flex-shrink: 0;
}

.record-type {
  color: #409EFF;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-content {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-stats {
  display: flex;
  gap: 12px;
  font-size: 12px;
}

.finished {
  color: #67c23a;
}

.unfinished {
  color: #f56c6c;
}

.record-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 8px;
}

.personal-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  justify-content: flex-end;
}

.class-list {
  margin-top: 12px;
}

.class-item {
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
}

.class-item.current {
  border-color: #409EFF;
  background: #f0f7ff;
}

.class-main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.class-name {
  font-weight: bold;
}

.student-count {
  color: #909399;
  font-size: 13px;
}

.other-subjects {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.subject-tag {
  font-size: 12px;
  color: #909399;
}

.about-content {
  padding: 16px;
}

.about-section {
  margin-bottom: 20px;
}

.about-section h3 {
  font-size: 16px;
  margin-bottom: 10px;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 8px;
}

.about-section .intro-text {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin-bottom: 8px;
  text-align: justify;
}

.about-section .feature-list {
  list-style: none;
  padding-left: 0;
}

.about-section .feature-item {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.about-section .feature-item i {
  color: #67c23a;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.about-section .feature-item span {
  flex: 1;
}

.tech-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tech-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 8px;
}

.tech-icon {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  margin-right: 12px;
  flex-shrink: 0;
}

.tech-icon.backend {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.tech-icon.frontend {
  background: linear-gradient(135deg, #42b883 0%, #35495e 100%);
}

.tech-icon.database {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.tech-icon.auth {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.tech-details {
  flex: 1;
}

.tech-name {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 4px 0;
}

.tech-desc {
  font-size: 12px;
  color: #909399;
  margin: 0;
}

.author-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.author-basic p {
  font-size: 14px;
  color: #606266;
  margin: 0 0 8px 0;
}

.wechat-qrcode {
  text-align: center;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
}

.wechat-label {
  font-size: 14px;
  color: #303133;
  margin: 0 0 4px 0;
}

.wechat-tip {
  font-size: 12px;
  color: #909399;
  margin: 0 0 12px 0;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.add-students-tip {
  margin-bottom: 12px;
}

.add-students-tip p {
  margin: 0;
  font-size: 14px;
}

.sub-tip {
  color: #909399;
  font-size: 12px !important;
}

.edit-form .form-item {
  margin-bottom: 16px;
}

.edit-form .form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #606266;
}

.chinese-subject .management-header {
  background: linear-gradient(90deg, #40e0d0, #6abfd1);
  color: #fff;
}

.math-subject .management-header {
  background: linear-gradient(90deg, #40e0d0, #6abfd1);
  color: #fff;
}

.english-subject .management-header {
  background: linear-gradient(90deg, #40e0d0, #6abfd1);
  color: #fff;
}

.chinese-subject .back-btn,
.math-subject .back-btn,
.english-subject .back-btn {
  background: transparent;
  border: none;
  color: #fff;
}
</style>

<style>
.el-message {
  top: 54px !important;
}
</style>
